"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _FilterList = _interopRequireDefault(require("@material-ui/icons/FilterList"));

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _CatalogueProductListMultipleFilterMobileDialog = _interopRequireDefault(require("./CatalogueProductListMultipleFilterMobileDialog"));

var _CatalogueProductListOrderSelectorButton = _interopRequireDefault(require("./CatalogueProductListOrderSelectorButton"));

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    btnContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(2)
    },
    btn: (0, _defineProperty2.default)({
      backgroundColor: theme.palette.another.tabs,
      width: '50%',
      borderColor: theme.palette.common.black,
      borderRadius: 6
    }, theme.breakpoints.down('xs'), {
      width: '100%'
    })
  };
}, {
  name: 'ProductListMultipleFilterMobile'
});

var _ref2 = /*#__PURE__*/_react.default.createElement(_FilterList.default, null);

function ProductListMultipleFilterMobile(_ref) {
  var buildFilter = _ref.buildFilter,
      pClasses = _ref.classes,
      className = _ref.className,
      currency = _ref.currency,
      filter = _ref.filter,
      filterFields = _ref.filterFields,
      filterHash = _ref.filterHash,
      handleChangeOrder = _ref.handleChangeOrder,
      onChange = _ref.onChange,
      onChangeRowsPerPage = _ref.onChangeRowsPerPage,
      onChangeStockOnly = _ref.onChangeStockOnly,
      order = _ref.order,
      parentFilter = _ref.parentFilter,
      resetFilter = _ref.resetFilter,
      rowsPerPage = _ref.rowsPerPage,
      stockOnly = _ref.stockOnly,
      total = _ref.total,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["buildFilter", "classes", "className", "currency", "filter", "filterFields", "filterHash", "handleChangeOrder", "onChange", "onChangeRowsPerPage", "onChangeStockOnly", "order", "parentFilter", "resetFilter", "rowsPerPage", "stockOnly", "total"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();

  var _React$useState = _react.default.useState(false),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var handleTogleDialog = _react.default.useCallback(function (v) {
    setOpen(typeof v === 'boolean' ? v : function (ps) {
      return !ps;
    });
  }, []);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.btnContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    variant: "outlined",
    onClick: function onClick() {
      return handleTogleDialog(true);
    },
    className: classes.btn,
    endIcon: _ref2
  }, t('productListMultipleFilterMobile/title'))), /*#__PURE__*/_react.default.createElement(_CatalogueProductListOrderSelectorButton.default, {
    onChange: handleChangeOrder,
    onChangeRowsPerPage: onChangeRowsPerPage,
    onChangeStockOnly: onChangeStockOnly,
    stockOnly: stockOnly,
    rowsPerPage: rowsPerPage,
    value: order
  }), /*#__PURE__*/_react.default.createElement(_CatalogueProductListMultipleFilterMobileDialog.default, {
    open: open,
    onClose: handleTogleDialog,
    buildFilter: buildFilter,
    filter: filter,
    filterFields: filterFields,
    filterHash: filterHash,
    onChange: onChange,
    parentFilter: parentFilter,
    resetFilter: resetFilter,
    total: total,
    currency: currency
  }));
}

process.env.NODE_ENV !== "production" ? ProductListMultipleFilterMobile.propTypes = {
  buildFilter: _propTypes.default.func,
  classes: _propTypes.default.shape({
    btn: _propTypes.default.string,
    btnContainer: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  currency: _propTypes.default.string,
  filter: _propTypes.default.oneOfType([_propTypes.default.shape({}), _propTypes.default.shape(_propTypes.default.arrayOf())]),
  filterFields: _propTypes.default.arrayOf(_propTypes.default.string),
  filterHash: _propTypes.default.string,
  handleChangeOrder: _propTypes.default.func,
  onChange: _propTypes.default.func,
  onChangeRowsPerPage: _propTypes.default.func,
  onChangeStockOnly: _propTypes.default.func,
  order: _propTypes.default.string,
  parentFilter: _propTypes.default.arrayOf(_propTypes.default.shape()),
  resetFilter: _propTypes.default.func,
  rowsPerPage: _propTypes.default.number,
  stockOnly: _propTypes.default.bool,
  total: _propTypes.default.number
} : void 0;
ProductListMultipleFilterMobile.defaultProps = {
  buildFilter: undefined,
  classes: undefined,
  className: undefined,
  currency: undefined,
  filter: undefined,
  filterFields: undefined,
  filterHash: undefined,
  handleChangeOrder: undefined,
  onChange: undefined,
  onChangeRowsPerPage: undefined,
  onChangeStockOnly: undefined,
  order: undefined,
  parentFilter: undefined,
  resetFilter: undefined,
  rowsPerPage: undefined,
  stockOnly: undefined,
  total: undefined
};
var _default = ProductListMultipleFilterMobile;
exports.default = _default;